import React from 'react';
import PropTypes from 'prop-types';

import { Tooltip } from '@mui/material';

import { ReactComponent as PolarisLogo } from '../images/polaris-logo.svg';

import classes from './iconStyles.module.css';

const PolarisLogoIcon = ({ tooltipContent, customClass = '' }) => {
    return (
        <div className={`${classes.polarisLogoIcon} ${customClass ? classes[customClass] : ''}`}>
            <Tooltip title={tooltipContent} placement="top">
                <PolarisLogo
                    role="graphics-symbol"
                    data-testid="polaris-logo-icon">
                </PolarisLogo>
            </Tooltip>
        </div>
    );
};

PolarisLogoIcon.propTypes = {
    tooltipContent: PropTypes.string,
    customClass: PropTypes.string
};

export default PolarisLogoIcon;
